module.exports = {"id":"207421","name":"Leandro Trossard","rating":"73","photo":"./data/images/photos/0/207421.png","club":{"name":"KRC Genk","logo":"./data/images/clubs/KRCGenk.png"},"positions":["MG","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeandroTrossard0.json
// module id = 2458
// module chunks = 0